/**
 *
 * AnswerCard — tarjeta de respuesta para la vista de sentiment-analysis.
 * Separado de components/QuestionCard (usado por el widget de "Preguntas
 * cualitativas") para no afectar ese diseño.
 *
 */

import React from "react"
import SentimentIcon from "../../../../components/SentimentIcon"
import "./index.less"

function AnswerCard({ title, description, sentiment, division }) {
  return (
    <div className="AnswerCardComponent">
      <div className="AnswerCardComponent-header">
        {sentiment && <SentimentIcon sentiment={sentiment} />}
        <div className="AnswerCardComponent-header-text">
          <div className="AnswerCardComponent-title">{title}</div>
          {division && (
            <div className="AnswerCardComponent-division">
              <b>División:</b> {division}
            </div>
          )}
        </div>
      </div>
      <div className="AnswerCardComponent-text">{description}</div>
    </div>
  )
}

AnswerCard.propTypes = {}

export default AnswerCard
